import React from 'react';
import Iframe from 'react-iframe';

const ViewIndicadores = ({url}) => (
    <div>
        <Iframe 
            url={url}
            width="100%"
            height="700px"
            id="powerbiIframe"
            className="myClassname"
            display="initial"
            position="relative"
        />
    </div>
);

export default ViewIndicadores;
